import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgTtComponent } from './svg-tt.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgTtComponent],
  exports: [
    SvgTtComponent
  ]
})
export class SvgTtModule { }